import { TextField } from "@material-ui/core";
import React from "react";
import usePendingRequest from "../../../hooks/usePendingRequest";
import { useTranslation } from "../../../hooks/useTranslation";
import { useStyles } from "./PendingRequestSearchStyle";

const PendingRequestSearch = () => {
  const classes = useStyles();
  const { search, refreshDataTable } = usePendingRequest();
  const { t, BundleKey } = useTranslation();

  const handleChange = (value: string) => {
    if (value !== "") search(value);
    else refreshDataTable();
  };

  return (
    <TextField
      className={classes.search}
      id="search-pending-request"
      label={t(BundleKey.PENDINGREQUEST_SEARCH_PLACEHOLDER)}
      variant="outlined"
      onChange={(e: any) => handleChange(e.target.value)}
      fullWidth
    />
  );
};

export default PendingRequestSearch;
